/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_SpaInputs */

const en_svtag_spa = /** @type {(inputs: Svtag_SpaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SPA`)
};

const ar_svtag_spa = /** @type {(inputs: Svtag_SpaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#تطبيق_أحادي`)
};

const bn_svtag_spa = /** @type {(inputs: Svtag_SpaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SPA`)
};

const de_svtag_spa = /** @type {(inputs: Svtag_SpaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SPA`)
};

const es_svtag_spa = /** @type {(inputs: Svtag_SpaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SPA`)
};

const fr_svtag_spa = /** @type {(inputs: Svtag_SpaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SPA`)
};

const pt_svtag_spa = /** @type {(inputs: Svtag_SpaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SPA`)
};

const zh_svtag_spa = /** @type {(inputs: Svtag_SpaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SPA`)
};

const tr_svtag_spa = /** @type {(inputs: Svtag_SpaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SPA`)
};

const ru_svtag_spa = /** @type {(inputs: Svtag_SpaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SPA`)
};

const pl_svtag_spa = /** @type {(inputs: Svtag_SpaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SPA`)
};

/**
* | output |
* | --- |
* | "#SPA" |
*
* @param {Svtag_SpaInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_spa = /** @type {((inputs?: Svtag_SpaInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_SpaInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_spa(inputs)
	if (locale === "bn") return bn_svtag_spa(inputs)
	if (locale === "de") return de_svtag_spa(inputs)
	if (locale === "es") return es_svtag_spa(inputs)
	if (locale === "fr") return fr_svtag_spa(inputs)
	if (locale === "pt") return pt_svtag_spa(inputs)
	if (locale === "zh") return zh_svtag_spa(inputs)
	if (locale === "tr") return tr_svtag_spa(inputs)
	if (locale === "ru") return ru_svtag_spa(inputs)
	if (locale === "pl") return pl_svtag_spa(inputs)
	return en_svtag_spa(inputs)
});